import React, { useEffect, useState } from "react";
import Row from "../../common/layout/row";
import Grid from "../../common/layout/grid";
import DateFormat from "../../common/dateFormat/DateFormat";
import { getListaGraficoEnergiaDia, montarGraficoLineEnergiaDia, setDataGrafico } from "../geracaoLeituraActions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

function GraficoDiaComponent(props) {
    const [graficoDia, setGraficoDia] = useState(null);

    useEffect(() => {
        props.getListaGraficoEnergiaDia({
            id_agrupador: props.filtro.agrupar_por_uc ? props.registro.id_unidade_consumidora : props.registro.id_geracao_integracao,
            data: props.dataGrafico,
        });
    }, [props.filtro.agrupar_por_uc, props.registro.id_unidade_consumidora, props.registro.id_geracao_integracao, props.dataGrafico]);

    useEffect(() => {
        montarGraficoLineEnergiaDia({
            id: "graficoEnergiaDia",
            lista: props.listaGraficoEnergiaDia,
            setChart: setGraficoDia,
            subtitulo: props.registro.nome_unidade_consumidora,
        });
        return () => {
            if (graficoDia) {
                graficoDia.dispose();
            }
        };
    }, [props.listaGraficoEnergiaDia, props.registro.nome_unidade_consumidora]);

    function voltarAvancarDataGrafico({ dataGrafico, tempo }) {
        const novaData = new Date(dataGrafico);
        novaData.setUTCDate(novaData.getUTCDate() + tempo);
        props.setDataGrafico(novaData.toISOString().substring(0, 10));
    }

    function getEstiloBotao(desabilitado) {
        return {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "1.5rem",
            fontWeight: 500,
            boxShadow: desabilitado ? "inset 0 0 16px 1px #ccc" : "0 0 10px 1px #ccc",
            color: "#0070cc",
            width: 40,
            height: 40,
            borderRadius: "100%",
            backgroundColor: "#fff",
            border: "none",
            marginInline: 20,
        };
    }
    return (
        <Row>
            <Grid
                cols="12 12 12 12"
                style={{
                    display: "flex",
                    minWidth: "fit-content",
                    justifyContent: "center",
                    alignItems: "center",
                    paddingTop: 10,
                }}
            >
                <button
                    style={getEstiloBotao()}
                    onFocus={(e) => {
                        e.target.style.outline = "none";
                    }}
                    onClick={() => {
                        voltarAvancarDataGrafico({
                            dataGrafico: props.dataGrafico,
                            tempo: -1,
                        });
                    }}
                    disabled={false}
                >
                    {"<"}
                </button>
                <input
                    style={{
                        fontSize: "1.2rem",
                        padding: 7,
                        border: "1px solid #999",
                        borderRadius: 10,
                    }}
                    required
                    type="date"
                    value={props.dataGrafico}
                    max={DateFormat.getDataAtual().replace(/\//g, "-")}
                    onFocus={(e) => (e.target.style.outline = "none")}
                    onChange={(e) => {
                        if (e.target.value) {
                            props.setDataGrafico(e.target.value);
                        }
                    }}
                ></input>
                <button
                    style={getEstiloBotao(props.dataGrafico === new Date().toISOString().substring(0, 10))}
                    onFocus={(e) => {
                        e.target.style.outline = "none";
                    }}
                    onClick={() => {
                        voltarAvancarDataGrafico({
                            dataGrafico: props.dataGrafico,
                            tempo: 1,
                        });
                    }}
                    disabled={props.dataGrafico === new Date().toISOString().substring(0, 10)}
                >
                    {">"}
                </button>
            </Grid>

            <div
                id="graficoEnergiaDia"
                style={{
                    width: "100%",
                    backgroundColor: "#ffffff",
                    height: 600,
                    borderRadius: "0 0 8px 8px",
                    overflow: "hidden",
                }}
            ></div>
        </Row>
    );
}

const mapStateToProps = (state) => {
    return {
        filtro: state.geracaoLeitura.filtro,
        modoTela: state.geracaoLeitura.modoTela,
        registro: state.geracaoLeitura.registro,
        dataGrafico: state.geracaoLeitura.dataGrafico,
        listaGraficoEnergiaDia: state.geracaoLeitura.listaGraficoEnergiaDia,
    };
};
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getListaGraficoEnergiaDia,
            setDataGrafico,
        },
        dispatch
    );
export const GraficoDia = connect(mapStateToProps, mapDispatchToProps)(GraficoDiaComponent);
